import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	yearly: {
		id: 'sisu.paymentPlan.yearly',
		defaultMessage: 'Yearly',
		description: 'Capitalized label for yearly billing period displayed in payment plan UI',
	},
	monthly: {
		id: 'sisu.paymentPlan.monthly',
		defaultMessage: 'Monthly',
		description: 'Capitalized label for monthly billing period displayed in payment plan UI',
	},
});
